var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"width":"100%","min-height":"calc(100vh - 110px)","zoom":"normal","border":"0"},attrs:{"src":`https://academica.etonhouse.com/headless/MedicalInfo/Users/${_vm.userId}/Schools/${_vm.schoolId}`,"title":"Academica"}})
}
var staticRenderFns = []

export { render, staticRenderFns }